<div class="usan-form-item sequence-structural-info-oligonucleotides-short-peptides-container">
  <div class="usan-checklist-item">
    <div class="usan-checklist-icon-column">
      <mat-icon>{{ wasFileUploaded ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
    </div>
    <div class="usan-checklist-content-column flex-wrap">
      <span class="required-star" *ngIf="isDocumentRequired">*</span>
      <span class="usan-form-item sequence-item sequence-text" [innerHTML]="title">
      </span>
      <div class="break"></div>
      <div class="usan-form-item sequence-item sequence-text" *ngIf="isFormBType || isFormFType">
        <ul>
          <li>All information required for proteins and peptides</li>
          <li>
            <a href="http://www.imgt.org/" class="link" target="_blank">
              CDR-IMGT and sequence analysis of the variable regions showing percentage of human content
            </a>
          </li>
          <li>CDR-Kabat (sequence and residue range)</li>
          <li>IG class and subclass, IG format</li>
          <li>Species or taxonomy related structure (chimeric, humanized, etc.)</li>
          <li>Name and/or structure of targeted antigen</li>
          <li>Expression system</li>
          <li>Clone name(s) and laboratory code name(s)</li>
          <li>If appropriate, the closest human V, J, and C genes and alleles (results obtained with IMGT/DomainGapAlign tool)</li>
          <li>If the terminal lysine is absent in the heavy chain amino acid sequence, a statement confirming that indeed there 
            is no lysine codon in the nucleotide sequence (if not the lysine should be added in the amino acid sequence mentioning 
            the posttranslational modification clipping)</li>
          <li>NEW! A list of all engineered mutations in the constant region, their locations, and their purpose</li>
        </ul>
      </div>
      <div class="usan-form-item sequence-item sequence-text" *ngIf="isFormDType">
        <ul>
          <li>
            <a href="https://www.ama-assn.org/sites/ama-assn.org/files/corp/media-browser/public/usan/sequence-request-format-mab_0.doc" class="link" target="_blank">
              Complete mature amino acid sequence in a Microsoft Word document
            </a>
          </li>
          <li>Please ensure that the CAS Registry information includes the sequence, disulfide bridges and glycosylations</li>
          <li>A MS-Word single-letter codes for each amino acid, displayed in groups of 10 characters with 5 groups per line and a number 
            indicating the position of the last amino acid at the end of each line</li>
          <li>Glycosylation patterns, including site and type of sugar, etc.</li>
          <li>Precursor nucleotide sequence with spaces between codons and translation, with numbered lines</li>
          <li>
            <a href="http://www.imgt.org/" class="link" target="_blank">
              CDR-IMGT and sequence analysis of the variable regions showing percentage of human content (if -ximab, -zumab, or -umab is requested; 
              &gt;90% -umab, -zumab is typically &gt;85%, &lt;85% -ximab)
            </a>
          </li>
          <li>CDR-Kabat (sequence and residue range)</li>
          <li>IG class and subclass, IG format</li>
          <li>Species or taxonomy related structure (chimeric, humanized, etc.)</li>
          <li>Name and/or structure of targeted antigen</li>
          <li>List of all disulfide bridges and their locations</li>
          <li>Expression system</li>
          <li>Clone name(s) and laboratory code name(s)</li>
          <li>If appropriate, the closest human V, J, and C genes and alleles (results obtained with IMGT/DomainGapAlign tool)</li>
          <li>For the V-domains, if the domains are nominally human (e.g. produced from human antibodies, EBV immortalization of human B-cells, 
            human phage display libraries, transgenic mice with human V-domain genes, or similar), the closest human gene/allele should be given</li>
          <li>If the V-domains have been humanized by CDR-grafting onto a human framework, the closest human gene/allele to the parent human 
            framework should be given</li>
          <li>Otherwise the closest germline (human or other species) should be given</li>
          <li>If the terminal lysine is absent in the heavy chain amino acid sequence, a statement confirming that indeed there is no lysine 
            codon in the nucleotide sequence (if not the lysine should be added in the amino acid sequence mentioning the posttranslational 
            modification clipping)</li>
          <li>If relevant, amino acid differences with the native sequence (for a monoclonal antibody: constant region amino acid changes by 
            comparison with the closer genomic C gene and allele)</li>
        </ul>
      </div>
    </div>
  </div>
  <div class="input-error" *ngIf="showRequiredError">
    This is a required document.
  </div>
  <div class="usan-form-item button-layout layout-centered">
    <button type="button" class="upload-sequence-structural-info-oligonucleotides-short-peptides form-btn form-btn-style form-btn-text"
      (click)="openDialog()">
      <mat-icon class="form-btn-icon">upload</mat-icon>
      Upload sequence
    </button>
  </div>
  <ng-container *ngIf="wasFileUploaded">
    <div class="full-width" *ngFor="let file of attachments">
      <app-uploaded-file [requiresAdmin]="false" [attachment]="file"></app-uploaded-file>
    </div>
  </ng-container>
</div>